import defaultErrorHandler from "actions/global/default-error-handler";

import {
  BIKE_HISTORY_LOADING,
  BIKE_HISTORY_ERROR,
  BIKE_HISTORY_FILTERS,
  BIKE_HISTORY_LIST
} from "actions/bike-history/constants";
import { requestCommonFilters, requestCommonSearch } from "../common/requests";

export const setLoading = (status) => ({
  type: BIKE_HISTORY_LOADING,
  payload: status
});

export const getBikeHistoryList = (page = 0, size = 20, sort = "date,DESC", filters = []) => dispatch => {
  dispatch(setLoading(true));
  requestCommonSearch("bike/history", page, size, sort, filters)
    .then((response) => {
      dispatch({
        type: BIKE_HISTORY_LIST,
        payload: response
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, BIKE_HISTORY_ERROR));
    });
};

export const getBikeHistoryFilters = () => dispatch => {
  dispatch(setLoading(true));
  requestCommonFilters("bike/history")
    .then((response) => {
      dispatch({
        type: BIKE_HISTORY_FILTERS,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, BIKE_HISTORY_ERROR));
    });
};



// WEBPACK FOOTER //
// ./src/actions/bike-history/actions.js